export enum LanguageCode {
  ENGLISH = 'en',
  FRENCH = 'fr',
  SPANISH = 'es',
  GERMAN = 'de',
  DUTCH = 'nl',
}

export type Language = {
  readonly displayName: string;
  readonly code: LanguageCode;
};

export enum CountryCode {
  UNITED_STATES = 'US',
  CANADA = 'CA',
  ARGENTINA = 'AR',
  UNITED_KINGDOM = 'GB',
  GERMANY = 'DE',
  AUSTRIA = 'AT',
  IRELAND = 'IE',
  NETHERLANDS = 'NL'
}

export type Country = {
  readonly displayName: Partial<Record<LanguageCode, string>>;
  readonly code: CountryCode;
  readonly languages: Language[]; // The first language in the array is assumed to be the default
  readonly dataCenter: DataCenter;
};

export enum DataCenterCode {
  NORTH_AMERICA = 'NA',
  LATIN_AMERICA = 'LA',
  EUROPE = 'EU',
}

export type DataCenter = {
  displayName: string;
  code: DataCenterCode;
  prodHost: string;
  stgHost: string;
  devHost: string;
}

export class Locale {
  readonly code: string; // Example: en-US
  readonly country: Readonly<Country>;
  readonly languageCode: LanguageCode;
  readonly dataCenter: DataCenter;

  constructor(country: Country, language: Language) {
    this.country = country;
    this.languageCode = language.code;
    this.code = `${language.code.toLowerCase()}-${country.code.toUpperCase()}`;
    this.dataCenter = country.dataCenter;
  }
}
